import React, { useState } from 'react'
import {Link} from "react-router-dom"
import "./Login.css"

function ForgetPass(props) {
    const validPhone = new RegExp("^09[1-3][0-9]{7}$");
    const [phoneErr, setPhoneErr] = useState(true);
    const [phoneNumber, setPhoneNumber] = useState('')
    const setAndCheckPhoneHandler = (e) => {
        setPhoneNumber(e.target.value)
        if (!validPhone.test(phoneNumber)) {
            setPhoneErr(true)
        } else {
            setPhoneErr(false)
        }
    }
    const [stepTwo, setStepTwo] = useState(false)
    const [lastStep, setLastStep] = useState(false)

    const moveStepTwoHandler = () => {
        setStepTwo(!stepTwo)
    }
    const moveLastStepHandler = () => {
        setLastStep(!lastStep)
    }
    return (
        <>
            <div className={`w-full h-screen backdrop-blur-md z-50 flex items-center justify-center absolute top-0 fade-in`}>
                <div className='bg-white shadow-main p-8 text-green-900 rounded flex flex-col gap-2 items-center justify-center'>
                    <p className='font-bold'>جهت بازیابی رمز درخواست خود را ثبت کنید</p>
                    <p>همکاران ما در اسرع وقت با شما تماس حاصل میکنند</p>
                    <div className='flex items-center justify-center gap-4 w-full mt-4'>
                        <button onClick={() => moveStepTwoHandler()} className='bg-green-900 text-white px-4 py-1  border-2 border-green-900 rounded-md flex-1 '>
                            ثبت درخواست
                        </button>
                        <button onClick={props.showForgetModalHandler} className='border-2 border-green-900 text-green-900 px-4 py-1 rounded-md flex-1'>
                            بستن
                        </button>
                    </div>
                </div>
            </div>
            {
                stepTwo ? (
                    <div className={`w-full h-screen backdrop-blur-md z-50 flex items-center justify-center absolute top-0 fade-in`}>
                        <div className='bg-white shadow-main p-8 text-green-900 rounded flex flex-col gap-2 items-center justify-center'>
                            <p className='font-bold mb-4'>شماره همراه خود را وارد کنید</p>
                            <div>
                                <label className='text-gray-900' htmlFor="phone">شماره تماس</label>
                                <input
                                    onChange={(e) => setAndCheckPhoneHandler(e)}
                                    value={phoneNumber}
                                    className='bg-gray-100 w-full rounded border-2 outline-none p-1 mt-1' type="text" name="phone" id="" />
                                {
                                    phoneErr ? (
                                        <p className='text-start pr-2 text-[12px] text-red-800 mt-2'>
                                            شماره تلفن معتبر نمی باشد
                                        </p>
                                    ) : ""
                                }
                            </div>
                            <div className='flex items-center justify-center gap-4 w-full mt-4'>
                                <button 
                                onClick={() => moveLastStepHandler()} 
                                className={` bg-green-900 text-white w-[60%] py-1 border-2 border-green-900 rounded-md`}>
                                    ثبت
                                </button>
                            </div>
                        </div>
                    </div>
                ) : ""
            }
            {
                lastStep ? (
                    <div className={`w-full h-screen backdrop-blur-md z-50 flex items-center justify-center absolute top-0 fade-in`}>
                        <div className='bg-white shadow-main p-8 text-green-900 rounded flex flex-col gap-2 items-center justify-center'>
                            <p className='font-bold'>درخواست شما با موفقیت ثبت شد</p>
                            <p>همکاران ما در اسرع وقت با شما تماس حاصل میکنند</p>
                            <div className='flex items-center justify-center gap-4 w-full mt-4'>
                                <Link onClick={props.showForgetModalHandler} to={"/"} className='text-center bg-green-900 text-white w-[60%] py-1 border-2 border-green-900 rounded-md '>
                                    بستن
                                </Link>
                            </div>
                        </div>
                    </div>
                ) : ""
            }
        </>
    )
}

export default ForgetPass